import createB2BBillingCommandQuery from './billing/createB2BBillingCommandQuery';
import createCreditNoteCommand from './billing/createCreditNoteCommand';
import getBillingByIdQuery from './billing/getBillingByIdQuery';
import updateBillingStatusCommandQuery from './billing/updateBillingStatusCommandQuery';
import { createOrUpdatePaymentAccountCommand } from './createOrUpdatePaymentAccountCommand';
import createOrUpdateStripeSellerAccount from './createOrUpdateStripeSellerAccount';
import createPaymentFromDirectPaymentServiceTypeCommand from './createPaymentFromDirectPaymentServiceTypeCommand';
import { createSellerPricingPlanBillingConfigurationCommand } from './createSellerPricingPlanBillingConfigurationCommand';
import { deletePaymentAccountCommand } from './deletePaymentAccountCommand';
import deleteStripeSellerAccount from './deleteStripeSellerAccount';
import getFilePaymentsQuery from './getFilePaymentsQuery';
import { getInvoicesQuery } from './getInvoicesQuery';
import getOpenedInvoiceQuery from './getOpenedInvoiceQuery';
import { getPaymentAccountsBySellerQuery } from './getPaymentAccountsBySellerQuery';
import getSellerStripeSecretKey from './getSellerStripeSecretKey';
import makeRefundCommand from './makeRefundCommand';
import regenerateBillingDocumentCommand from './regenerateBillingDocumentCommand';
import getBillingsQuery from './seller/getBillingsQuery';
import validatePaymentCommand from './validatePaymentCommand';

export const PaymentService = {
  createOrUpdateStripeSellerAccount,
  deleteStripeSellerAccount,
  getSellerStripeSecretKey,
  getFilePaymentsQuery,
  validatePaymentCommand,
  createPaymentFromDirectPaymentServiceTypeCommand,
  getOpenedInvoiceQuery,
  makeRefundCommand,
  regenerateBillingDocumentCommand,
  getInvoicesQuery,
  createOrUpdatePaymentAccountCommand,
  deletePaymentAccountCommand,
  getPaymentAccountsBySellerQuery,
  getBillingsQuery,
  createB2BBillingCommandQuery,
  getBillingByIdQuery,
  updateBillingStatusCommandQuery,
  createSellerPricingPlanBillingConfigurationCommand,
  createCreditNoteCommand,
};
